import { ref } from '../config/constants';
import { currentUser } from './auth';

export function getSubscription(id) {
  return fetch(`${process.env.REACT_APP_API_URI}/api/v1/stripe/${id}`)
    .then((plan) => {
      return plan.json();
    })
    .then((plan) => {
      return plan;
    });
}

export function updateSubscription(plan) {
  const user = currentUser();
  return ref
    .child(`users/${user.uid}/plan`)
    .set(plan)
    .then(() => {
      // Get user info
      let plan = ref.child(`/users/${user.uid}`).once('value');
      return plan;
    })
    .then((snapshot) => {
      // Return info snapshot
      return snapshot.val();
    });
}



// WEBPACK FOOTER //
// ./src/helpers/subscription.js